<template>
  <div>
    <swiper
      ref="volSwiper"
      class="volunteer"
      :options="volOpt"
      @slideChange="setIndex"
    >
      <swiper-slide
        class="volunteer__slide"
        v-for="slide in slidesVol"
        :key="slide.nameKey"
      >
        <div class="volunteer__wrap">
            <div class="volunteer__wrap-left">
                <h1 class="volunteer__title">
                    {{$store.getters.t(slide.nameKey)}}

                </h1>
                <p>{{$store.getters.t(slide.descriptionKey)}}</p>
                <div
                    class="swiper-pagination volunteer__pagination"
                    :class="selectColor"
                ></div>
            </div>
          <div class="volunteer__pic">
            <svg-icon :name="slide.pathTop" :title="$store.getters.t(slide.nameKey)" />
          </div>
        </div>
        <div class="volunteer__legs">
          <svg-icon :name="slide.pathBot" :title="$store.getters.t(slide.nameKey)" />
        </div>
      </swiper-slide>
    </swiper>
    <div class="volunteer__nav">
      <div id="volunteer-prev" class="swiper-button-prev" slot="button-prev"></div>
      <div id="volunteer-next" class="swiper-button-next" slot="button-next"></div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import SvgIcon from '../SvgIcon'

export default {
  name: 'VolonteerBlock',
  data: () => ({
    slidesVol: [
      {
        nameKey: 'volunteer_block_slide_1_title',
        descriptionKey: 'volunteer_block_slide_1_desc',
        className: 'first',
        pathTop: 'vs-1',
        pathBot: 'vsb-1'
      },
      {
        nameKey: 'volunteer_block_slide_2_title',
        descriptionKey: 'volunteer_block_slide_2_desc',
        className: 'second',
        pathTop: 'vs-2',
        pathBot: 'vsb-2'
      },
      {
        nameKey: 'volunteer_block_slide_3_title',
        descriptionKey: 'volunteer_block_slide_3_desc',
        className: 'third',
        pathTop: 'vs-3',
        pathBot: 'vsb-3'
      },
      {
        nameKey: 'volunteer_block_slide_4_title',
        descriptionKey: 'volunteer_block_slide_4_desc',
        className: 'four',
        pathTop: 'vs-4',
        pathBot: 'vsb-4'
      },
      {
        nameKey: 'volunteer_block_slide_5_title',
        descriptionKey: 'volunteer_block_slide_5_desc',
        className: 'five',
        pathTop: 'vs-5',
        pathBot: 'vsb-5'
      }
    ],
    selectColor: 'first',
    volOpt: {
      slidesPerView: 1,
      spaceBetween: 10,
      speed: 800,
        observer: true,
        observeParents: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: false
      },
      navigation: {
        nextEl: '#volunteer-next',
        prevEl: '#volunteer-prev'
      }
    }
  }),
  components: { Swiper, SwiperSlide, SvgIcon },
  computed: {
    swiper() {
      return this.$refs.volSwiper.$swiper
    }
  },

    mounted(){
    },
  methods: {
    setIndex() {
      this.slidesVol.forEach((el, idx) => {
        if (idx === this.swiper.activeIndex) {
          this.selectColor = el.className
        }
      })

    }
  }
}
</script>

<style lang="scss">
.volunteer {
  margin: 10px auto;
  margin-bottom: 0;
  &__wrap {
      position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 10px;
      max-width: 900px;
      margin: 0 auto;
      &-left{
          padding-right: 15px;
          max-width: 450px;
      }
  }
  &__title {
    font-family: 'Comfortaa', sans-serif;
    font-size: 24px;
    line-height: 32px;
    color: #333333;

  }
  &__pic {
    width: 368px;
    height: 216px;
    background: #ffffff;
    //box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
    border-radius: 3px;
    .svg-icon {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &__pagination {
      position: static;
    width: 288px;
    border-radius: 5px;
    height: 3px;
    display: flex;
    .swiper-pagination-bullet {
      width: 20%;
      height: 3px;
      display: inline-block;
      background: transparent;
      opacity: 1;
      outline: none;
      border-radius: 5px;
      transition: background 0.3s linear;
      &-active {
        opacity: 1;
      }
    }
    &.first {
      background: #fef1f1;
      .swiper-pagination-bullet {
        &-active {
          background: #ee7372;
        }
      }
    }
    &.second {
      background: #fef9ec;
      .swiper-pagination-bullet {
        &-active {
          background: #f6c143;
        }
      }
    }
    &.third {
      background: #f4fbf0;
      .swiper-pagination-bullet {
        &-active {
          background: #91da66;
        }
      }
    }
    &.four {
      background: #eaf1fc;
      .swiper-pagination-bullet {
        &-active {
          background: #2e76e4;
        }
      }
    }
    &.five {
      background: #f1eef9;
      .swiper-pagination-bullet {
        &-active {
          background: #6c4dbb;
        }
      }
    }
  }
  &__legs {
    margin-top: 85px;
    .svg-icon {
      max-width: 847px;
      width: 100%;
      min-height: 175px;
        margin: 0 auto;
    }

  }
  &__nav {
    display: flex;
    justify-content: center;
    margin-top: -4px;
      background: #eaf1fc;
    padding-top: 30px;
    .swiper-button-prev,
    .swiper-button-next {
      position: static;
      outline: none;
      background: #fff;
      border-radius: 20px;
      padding: 15px 20px;
      width: auto;
      height: auto;
      margin: 0 5px;
    }
    .swiper-button-prev {
      &::after {
        content: '';
        background: url('/assets/images/arrow-r.svg') no-repeat center;
        background-size: cover;
        width: 15px;
        height: 10px;
        transform: rotate(-180deg);
      }
    }
    .swiper-button-next {
      &::after {
        content: '';
        background: url('/assets/images/arrow-r.svg') no-repeat center;
        background-size: cover;
        width: 15px;
        height: 10px;
      }
    }
  }
}
@media (max-width: 768px) {
  .volunteer {
    &__wrap {
      flex-direction: column;
      justify-content: center;
      align-items: center;

        &-left{
            width: 100%;
            padding-right: 0;
        }
    }
    .swiper-pagination {
      position: static;
      margin: 40px 0;
    }
    &__slide {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 600px !important;
    }
    &__nav {
      margin-top: 0;
    }
    &__legs {
      margin-top: 15px;
      //margin-bottom: -15px;
      .svg-icon {
        max-width: 100%;
        width: 100%;
        //height: 120px;
        min-height: auto;
      }
    }
  }
}

@media (max-width: 768px){
    .volunteer__pagination{
        width: 100%;
    }
    .volunteer__pagination .swiper-pagination-bullet{
        width: 20%;
    }
}

@media (max-width: 600px){
    .volunteer__wrap{
        width: 100%;
    }

    .volunteer__pic .svg-icon img{
        width: 100%;
    }
}

@media (max-width: 576px) {
  .volunteer {
    &__slide {
      //height: 500px !important;
    }
    &__pic {
      width: 100%;
      height: 100%;
    }
    &__legs {
      //.svg-icon {
      //  height: 92px;
      //}
    }
  }
}
</style>
